import { createAction } from 'redux-actions';

const actions = {
  /**
   * [브랜드] 브랜드 페이지 데이터 변경하기
   */
  SET_DATA: 'store/SET_DATA',
  setData: createAction('store/SET_DATA'),

  /**
   * [브랜드] 입점승인 브랜드 리스트 요청하기
   */
  GET_BRAND_JOIN_LIST_REQUEST: 'store/GET_BRAND_JOIN_LIST_REQUEST',
  GET_BRAND_JOIN_LIST_SUCCESS: 'store/GET_BRAND_JOIN_LIST_SUCCESS',
  getBrandJoinList: createAction('store/GET_BRAND_JOIN_LIST_REQUEST'),

  /**
   * [브랜드] 입점승인 브랜드 excel 리스트 다운로드 하기
   */
  GET_BRAND_JOIN_EXCEL_DOWNLOAD_REQUEST: 'store/GET_BRAND_JOIN_EXCEL_DOWNLOAD_REQUEST',
  GET_BRAND_JOIN_EXCEL_DOWNLOAD_SUCCESS: 'store/GET_BRAND_JOIN_EXCEL_DOWNLOAD_SUCCESS',
  getBrandJoinExcelDownload: createAction('store/GET_BRAND_JOIN_EXCEL_DOWNLOAD_REQUEST'),

  /**
   * [브랜드] 브랜드 리스트 페이지 전체 데이터 요청하기
   */
  GET_BRAND_ALL_INFO_REQUEST: 'store/GET_BRAND_ALL_INFO_REQUEST',
  GET_BRAND_ALL_INFO_SUCCESS: 'store/GET_BRAND_ALL_INFO_SUCCESS',
  getBrandAllInfo: createAction('store/GET_BRAND_ALL_INFO_REQUEST'),

  /**
   * [브랜드] 브랜드 리스트 요청하기
   */
  GET_BRAND_LIST_REQUEST: 'store/GET_BRAND_LIST_REQUEST',
  GET_BRAND_LIST_SUCCESS: 'store/GET_BRAND_LIST_SUCCESS',
  getBrandList: createAction('store/GET_BRAND_LIST_REQUEST'),

  /**
   * [브랜드] 브랜드 excel 리스트 다운로드 하기
   */
  GET_BRAND_EXCEL_DOWNLOAD_REQUEST: 'store/GET_BRAND_EXCEL_DOWNLOAD_REQUEST',
  GET_BRAND_EXCEL_DOWNLOAD_SUCCESS: 'store/GET_BRAND_EXCEL_DOWNLOAD_SUCCESS',
  getBrandExcelDownload: createAction('store/GET_BRAND_EXCEL_DOWNLOAD_REQUEST'),

  /**
   * [브랜드] 브랜드 태그 검수 리스트 요청하기
   */
  GET_BRAND_TAG_REQUEST_LIST_REQUEST: 'store/GET_BRAND_TAG_REQUEST_LIST_REQUEST',
  getBrandTagRequestList: createAction('store/GET_BRAND_TAG_REQUEST_LIST_REQUEST'),

  /**
   * [브랜드] 브랜드 태그 검수 excel 리스트 다운로드 하기
   */
  GET_BRAND_TAG_REQUEST_EXCEL_DOWNLOAD_REQUEST: 'store/GET_BRAND_TAG_REQUEST_EXCEL_DOWNLOAD_REQUEST',
  getBrandTagRequestDownLoad: createAction('store/GET_BRAND_TAG_REQUEST_EXCEL_DOWNLOAD_REQUEST'),

  /**
   *  [브랜드] 브랜드 태그 리스트 요청하기
   */
  GET_BRAND_TAG_COLUMN_TAG_LIST_REQUEST: 'store/GET_BRAND_TAG_COLUMN_TAG_LIST_REQUEST',
  getBrandTagColumnTagList: createAction('store/GET_BRAND_TAG_COLUMN_TAG_LIST_REQUEST'),

  /**
   * [브랜드] 통계 정보 조회하기
   */
  GET_BRAND_DETAIL_STATISTIC_REQUEST: 'store/GET_BRAND_DETAIL_STATISTIC_REQUEST',
  GET_BRAND_DETAIL_STATISTIC_SUCCESS: 'store/GET_BRAND_DETAIL_STATISTIC_SUCCESS',
  getBrandDetailStatistic: createAction('store/GET_BRAND_DETAIL_STATISTIC_REQUEST'),

  /**
   * [브랜드] 브랜드 정보 조회하기
   */
  GET_BRAND_DETAIL_INFO_REQUEST: 'store/GET_BRAND_DETAIL_INFO_REQUEST',
  GET_BRAND_DETAIL_INFO_SUCCESS: 'store/GET_BRAND_DETAIL_INFO_SUCCESS',
  getBrandDetailInfo: createAction('store/GET_BRAND_DETAIL_INFO_REQUEST'),

  /**
   * [브랜드] 정산 정보 조회하기
   */
  GET_BRAND_DETAIL_ORDER_BALANCE_REQUEST: 'store/GET_BRAND_DETAIL_ORDER_BALANCE_REQUEST',
  GET_BRAND_DETAIL_ORDER_BALANCE_SUCCESS: 'store/GET_BRAND_DETAIL_ORDER_BALANCE_SUCCESS',
  getBrandDetailOrderBalance: createAction('store/GET_BRAND_DETAIL_ORDER_BALANCE_REQUEST'),

  /**
   * [브랜드] 상품 정보 조회하기
   */
  GET_BRAND_DETAIL_PRODUCT_REQUEST: 'store/GET_BRAND_DETAIL_PRODUCT_REQUEST',
  GET_BRAND_DETAIL_PRODUCT_SUCCESS: 'store/GET_BRAND_DETAIL_PRODUCT_SUCCESS',
  getBrandDetailProduct: createAction('store/GET_BRAND_DETAIL_PRODUCT_REQUEST'),

  /**
   * [브랜드] 공지사항 정보 조회하기
   */
  GET_BRAND_DETAIL_NOTICE_PRODUCT_REQUEST: 'store/GET_BRAND_DETAIL_NOTICE_PRODUCT_REQUEST',
  GET_BRAND_DETAIL_NOTICE_PRODUCT_SUCCESS: 'store/GET_BRAND_DETAIL_NOTICE_PRODUCT_SUCCESS',
  getBrandDetailNoticeProduct: createAction('store/GET_BRAND_DETAIL_NOTICE_PRODUCT_REQUEST'),

  /**
   * [브랜드] 상품등록 정보 조회하기
   */
  GET_BRAND_DETAIL_PRODUCT_REGISTER_REQUEST: 'store/GET_BRAND_DETAIL_PRODUCT_REGISTER_REQUEST',
  GET_BRAND_DETAIL_PRODUCT_REGISTER_SUCCESS: 'store/GET_BRAND_DETAIL_PRODUCT_REGISTER_SUCCESS',
  getBrandDetailProductRegister: createAction('store/GET_BRAND_DETAIL_PRODUCT_REGISTER_REQUEST'),

  /**
   * [브랜드] 상세 > 상품정보 > 상품 리스트 엑셀 다운로드
   */
  GET_BRAND_DETAIL_PRODUCT_EXCEL_DOWNLOAD_REQUEST: 'store/GET_BRAND_DETAIL_PRODUCT_EXCEL_DOWNLOAD_REQUEST',
  getBrandDetailProductExcelDownload: createAction('store/GET_BRAND_DETAIL_PRODUCT_EXCEL_DOWNLOAD_REQUEST'),

  /**
   * [브랜드] 상세 > 상품정보 > 상품 공지사항 엑셀 다운로드
   */
  GET_BRAND_DETAIL_NOTICE_EXCEL_DOWNLOAD_REQUEST: 'store/GET_BRAND_DETAIL_NOTICE_EXCEL_DOWNLOAD_REQUEST',
  getBrandDetailNoticeExcelDownload: createAction('store/GET_BRAND_DETAIL_NOTICE_EXCEL_DOWNLOAD_REQUEST'),

  /**
   * [브랜드] 브랜드 입점승인하기
   */
  PERMIT_BRAND_REQUEST: 'store/PERMIT_BRAND_REQUEST',
  PERMIT_BRAND_SUCCESS: 'store/PERMIT_BRAND_SUCCESS',
  permitBrand: createAction('store/PERMIT_BRAND_REQUEST'),

  /**
   * [브랜드] 브랜드 입점거절하기
   */
  REJECT_BRAND_REQUEST: 'store/REJECT_BRAND_REQUEST',
  REJECT_BRAND_SUCCESS: 'store/REJECT_BRAND_SUCCESS',
  rejectBrand: createAction('store/REJECT_BRAND_REQUEST'),

  /**
   * [브랜드] 브랜드 데이터 수정하기
   */
  EDIT_BRAND_REQUEST: 'store/EDIT_BRAND_REQUEST',
  EDIT_BRAND_SUCCESS: 'store/EDIT_BRAND_SUCCESS',
  editBrand: createAction('store/EDIT_BRAND_REQUEST'),

  /**
   * [브랜드] 브랜드 등록정보 수정하기
   */
  EDIT_BRAND_PRODUCT_REGISTER_REQUEST: 'store/EDIT_BRAND_PRODUCT_REGISTER_REQUEST',
  EDIT_BRAND_PRODUCT_REGISTER_REQUEST_SUCCESS: 'store/EDIT_BRAND_PRODUCT_REGISTER_REQUEST_SUCCESS',
  editBrandProductRegister: createAction('store/EDIT_BRAND_PRODUCT_REGISTER_REQUEST'),

  /**
   * [브랜드] 브랜드 티어 정보 요청하기
   */
  GET_BRAND_TIER_INFO_REQUEST: 'store/GET_BRAND_TIER_INFO_REQUEST',
  GET_BRAND_TIER_INFO_SUCCESS: 'store/GET_BRAND_TIER_INFO_SUCCESS',
  getBrandTierInfo: createAction('store/GET_BRAND_TIER_INFO_REQUEST'),

  /**
   * [브랜드] 브랜드 티어 셀렉터 검색하기
   */
  GET_BRAND_TIER_SELECTOR_LIST_REQUEST: 'store/GET_BRAND_TIER_SELECTOR_LIST_REQUEST',
  GET_BRAND_TIER_SELECTOR_LIST_SUCCESS: 'store/GET_BRAND_TIER_SELECTOR_LIST_SUCCESS',
  getBrandTierSelectorList: createAction('store/GET_BRAND_TIER_SELECTOR_LIST_REQUEST'),

  /**
   * [브랜드] 브랜드 티어 수정하기
   */
  EDIT_BRAND_TIER_LIST_REQUEST: 'store/EDIT_BRAND_TIER_LIST_REQUEST',
  EDIT_BRAND_TIER_LIST_SUCCESS: 'store/EDIT_BRAND_TIER_LIST_SUCCESS',
  editBrandTierListRequest: createAction('store/EDIT_BRAND_TIER_LIST_REQUEST'),

  /**
   * [브랜드] 브랜드 노출 리스트 정보 요청하기
   */
  GET_BRAND_EXPOSURE_INFO_REQUEST: 'store/GET_BRAND_EXPOSURE_INFO_REQUEST',
  GET_BRAND_TOP_EXPOSURE_INFO_SUCCESS: 'store/GET_BRAND_TOP_EXPOSURE_INFO_SUCCESS',
  getBrandExposureInfo: createAction('store/GET_BRAND_EXPOSURE_INFO_REQUEST'),

  /**
   * [브랜드] 브랜드 노출 리스트 셀렉터 검색하기
   */
  GET_BRAND_EXPOSURE_SELECTOR_LIST_REQUEST: 'store/GET_BRAND_EXPOSURE_SELECTOR_LIST_REQUEST',
  GET_BRAND_EXPOSURE_SELECTOR_LIST_SUCCESS: 'store/GET_BRAND_EXPOSURE_SELECTOR_LIST_SUCCESS',
  getBrandExposureSelectorList: createAction('store/GET_BRAND_EXPOSURE_SELECTOR_LIST_REQUEST'),

  /**
   * [브랜드] 브랜드 노출 리스트 수정하기
   */
  EDIT_BRAND_EXPOSURE_LIST_REQUEST: 'store/EDIT_BRAND_EXPOSURE_LIST_REQUEST',
  EDIT_BRAND_EXPOSURE_LIST_SUCCESS: 'store/EDIT_BRAND_EXPOSURE_LIST_SUCCESS',
  editBrandExposureListRequest: createAction('store/EDIT_BRAND_EXPOSURE_LIST_REQUEST'),

  /**
   *  브랜드 태그 승인하기
   */
  PERMIT_REGISTRATION_STORE_TAG_REQUEST: 'store/PERMIT_REGISTRATION_STORE_TAG_REQUEST',
  PERMIT_REGISTRATION_STORE_TAG_SUCCESS: 'store/PERMIT_REGISTRATION_STORE_TAG_SUCCESS',
  permitRegistrationStoreTag: createAction('store/PERMIT_REGISTRATION_STORE_TAG_REQUEST'),

  /**
   *  브랜드 태그 거절하기
   */
  REJECT_REGISTRATION_STORE_TAG_REQUEST: 'store/REJECT_REGISTRATION_STORE_TAG_REQUEST',
  REJECT_REGISTRATION_STORE_TAG_SUCCESS: 'store/REJECT_REGISTRATION_STORE_TAG_SUCCESS',
  rejectRegistrationStoreTag: createAction('store/REJECT_REGISTRATION_STORE_TAG_REQUEST'),

  /**
   * 모달 토글
   */
  TOGGLE_MODAL: 'store/TOGGLE_MODAL',
  toggleModal: createAction('store/TOGGLE_MODAL'),
};

export default actions;
